import React from "react";
import './style.css';

class FullPageLoading extends React.Component {
    render() {
        return (

            <>
                <div className={"modal fade in"} style={{display:'block'}}>
                    <div className="spiner-example" style={{marginTop:'30%',paddingTop:'0px'}}>
                        <div className="sk-spinner sk-spinner-three-bounce">
                            <div className="sk-bounce1"/>
                            <div className="sk-bounce2"/>
                            <div className="sk-bounce3"/>

                        </div>
                        <div style={{textAlign:'center',color:'white'}}>Đang tải dữ liệu</div>
                    </div>
                </div>
                <div className={"modal-backdrop fade in"}/>
            </>
        )
    }
}

export default FullPageLoading;
